import { CheckCircle2, Copy, QrCode } from "lucide-react";
import { Button } from "../../../ui/Button";
import { Card } from "../../../ui/Card";
import { Modal } from "../../../ui/Modal";

interface PixData {
	txid: string;
	brcode: string;
	idPagamento?: number;
}

interface QuotationPixModalProps {
	isOpen: boolean;
	onClose: () => void;
	onBackToClosing: () => void;
	orderNumber: number | null;
	pixData: PixData | null;
	pixQrImageUrl: string | null;
	pixCopiedFeedback: boolean;
	onCopyPixCode: () => void;
}

export function QuotationPixModal({
	isOpen,
	onClose,
	onBackToClosing,
	orderNumber,
	pixData,
	pixQrImageUrl,
	pixCopiedFeedback,
	onCopyPixCode,
}: QuotationPixModalProps) {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="PIX Gerado"
			size="md"
			className="sm:max-w-md"
		>
			<div className="space-y-4">
				<Card
					title="Cobranca pronta"
					description="Compartilhe o QR Code ou o Pix Copia e Cola com o cliente. Depois volte ao fechamento e use Salvar arquivo."
					className="bg-green-600/10 border-green-500/30"
				>
					<div className="space-y-3">
						<div className="p-2 bg-green-600/10 border border-green-500/20 rounded-lg">
							<div className="text-xs text-green-300 font-medium">Orcamento</div>
							<div className="text-base text-green-100 font-semibold">
								#{orderNumber ?? "--"}
							</div>
						</div>

						{pixQrImageUrl && (
							<div className="flex justify-center">
								<div className="p-3 bg-white rounded-xl shadow-md">
									<img
										src={pixQrImageUrl}
										alt="QR Code PIX"
										className="w-52 h-52 sm:w-60 sm:h-60 object-contain"
									/>
								</div>
							</div>
						)}

						<div className="space-y-2">
							<div className="flex items-center gap-2 text-xs text-gray-300">
								<QrCode className="w-3.5 h-3.5 text-cyan-300" />
								<span>Pix Copia e Cola</span>
							</div>
							<textarea
								readOnly
								value={pixData?.brcode || ""}
								className="w-full min-h-[112px] resize-none px-3 py-2 bg-navy-900 border border-navy-600 rounded-lg text-[11px] sm:text-xs text-white leading-relaxed focus:outline-none"
							/>
						</div>

						<Button
							variant="secondary"
							size="sm"
							onClick={onCopyPixCode}
							icon={pixCopiedFeedback ? CheckCircle2 : Copy}
							className={`w-full text-sm ${
								pixCopiedFeedback
									? "bg-green-500 hover:bg-green-600 text-white border-green-400"
									: "bg-emerald-600 hover:bg-emerald-700 text-white border-emerald-400/40"
							}`}
						>
							{pixCopiedFeedback ? "Pix Copiado" : "Copiar Pix (WhatsApp)"}
						</Button>
					</div>
				</Card>

				<div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
					<Button
						variant="secondary"
						size="sm"
						onClick={onBackToClosing}
						className="w-full text-sm"
					>
						Voltar ao fechamento
					</Button>
					<Button
						variant="success"
						size="sm"
						onClick={onClose}
						className="w-full text-sm"
					>
						Fechar
					</Button>
				</div>
			</div>
		</Modal>
	);
}
